import styled, { css } from 'styled-components';
import { contentCentered } from 'helpers/styles.js';
import sendWhite from 'images/icons/send_white.svg';
import globeWhite from 'images/icons/globeWhite.svg';
import globeBlue from 'images/icons/globeBlue.svg';
import saveWhite from 'images/icons/saveWhite.svg';
import paidContentBadge from 'images/icons/paidContentBadge.svg';
import ownedContentBadge from 'images/icons/ownedContentBadge.svg';

const iconMap = {
  send: sendWhite,
  view: globeWhite,
  save: saveWhite,
};

export const ContentType = styled.div`
  background: ${({ type }) => `url('${type === 'paid' ? paidContentBadge : ownedContentBadge}') 0px 0px no-repeat`};
  padding-left: 20px;
`;

export const IconTextBlock = styled.div`
  background: ${({ logo_url }) => `url('${logo_url}') 0px center no-repeat`};
  background-size: 30px 30px;
  padding-left: 35px;
  line-height: 30px;
  margin-bottom: 12px;
`;

export const PageLink = styled.a`
  display: block;
  background: url(${globeBlue}) left 2px no-repeat;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  padding-left: 24px;
  background-size: 13px;
  border-bottom: 1px solid transparent;

  &:hover{
    border-bottom: 1px solid ${({ theme }) => theme.colors.palette[5]};
  }

  &,
  &:visited,
  &:focus {
    color: ${({ theme }) => theme.colors.palette[5]};
  }
`;

export const ContentActionContainer = styled.div`
  width: 100%;
  height: 80px;
  color: white;
  ${contentCentered};
  text-align: left;
  transition: all .3s ${({ theme: { transition } }) => transition.bezier};

  @media (min-height: 700px) {
    height: 120px;
  }

  @media (min-height: 900px) {
    height: 180px;
  }
`;

export const ContentActionButton = styled.div`
  display: inline-block;
  border: ${({ theme }) => `1px solid ${theme.colors.palette[5]}`};
  box-sizing: border-box;
  background: ${({ type }) => `url('${iconMap[type]}') 12px 10px no-repeat`};
  transition: all .3s ${({ theme: { transition } }) => transition.bezier};
  background-size: 10px 10px;
  border-radius: 50px;
  padding: 10px 14px 10px 32px;
  margin-left: 5px;
  line-height: 12px;
  letter-spacing: 1px;
  font-size: 9px;
  text-transform: uppercase;

  color: #FFFFFF;

  &:hover {
    cursor: pointer;
    border-color: white;
  }

  ${({ active }) => active && css`
    background-color: ${({ theme }) => theme.colors.palette[7]};
    color: white;
    border-color: ${({ theme }) => theme.colors.palette[7]};
  `}
`;

export const HighlightKeywordsContainer = styled.div`
  display: inline-block;
  padding-right: 15px;
  font-weight: 100;
  font-size: 14px;
  color: #c6c6c6;
  letter-spacing: 2px;
`;

export const HighlightToggleContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;
